import { Card, CardContent, Grid2 } from '@mui/material';
import React, { useEffect } from 'react';
import { withErrorBoundary } from 'react-error-boundary';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import { SkeletonLoaderGrid } from '@components/SkeletonLoader';

import { useParameter } from '@hooks/useParameter';

import Header from './Form/Header';
import RiskForm from './Form/RiskForm';

const ReferenceRange: React.FC = () => {
  const { referenceRange, isInitialized } = useParameter();
  const loading = !isInitialized;

  const ranges = Array.from(referenceRange.entries()).map(([key, value]) => {
    return {
      risk: key,
      parameter: value,
    };
  });

  useEffect(() => {
    if (referenceRange.size < 1 && isInitialized) {
      history.back();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card sx={{ width: '100%' }}>
      <CardContent>
        <Header />

        <SkeletonLoaderGrid
          count={5}
          loading={loading}
          height={300}
          itemWidth={300}
        />
        {!loading && (
          <Grid2 container justifyContent="space-evenly" spacing={4}>
            {ranges.map(({ risk, parameter }) => {
              return (
                <RiskForm
                  key={`risk-card-${risk}`}
                  parameter={parameter}
                  risk={risk}
                />
              );
            })}
          </Grid2>
        )}
      </CardContent>
    </Card>
  );
};

export default withErrorBoundary(ReferenceRange, {
  FallbackComponent: ErrorBoundaryFallback,
});
